.assistant_panel {
  position: absolute;
  top: 58px;
  right: 8px;
  z-index: 20;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: min(420px, calc(100vw - 16px));
  padding: 12px;
  border: 1px solid
    var(--ion-color-light-shade, #e0e0e0);
  border-radius: 8px;
  background: var(--ion-color-light, #ffffff);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  color: var(--ion-color-text-primary);

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      font-weight: 600;
      /* Takes the slack so the language picker and the close
         button sit together on the right. */
      flex: 1;
    }
  }

  .summary,
  .clarification {
    margin: 0;
    font-size: 0.9rem;
  }

  .disclosure {
    margin: 0;
    font-size: 0.75rem;
    /* Present and readable, but not competing with the conversation. */
    opacity: 0.7;
  }

  .ai_badge {
    font-size: 0.7rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    opacity: 0.75;
  }

  .hint {
    margin: 0;
    font-size: 0.85rem;
    /* Quieter than a summary: it is guidance, not a result. */
    opacity: 0.75;
  }

  .loading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;

    p {
      margin: 0;
      font-size: 0.9rem;
    }
  }

  .unresolved {
    margin: 0;
    padding-left: 18px;
    font-size: 0.85rem;
    color: var(--ion-color-warning-shade, #b26a00);
  }

  .error {
    margin: 0;
    font-size: 0.9rem;
    color: var(--ion-color-danger, #c0392b);
  }
}
